export default __webpack_public_path__ + "img/search.272ccae9.svg";